import CryptoJS from './cryptojs';
import forEach from 'lodash.foreach';
import { objectAssign, serializeParam, loadScript, ajax } from '@tencent/midas-util';
import Promise from 'promise';
import sessionToken from './sessionToken';
import logdata from './logdata';

/**
 * 请注意，使用该模块你需要关注以下几个方法，看注释即可
 * 1. 初始化
        var cgiObj = new cgi(opt)
 * 2. 发起cgi请求
        cgiObj.request(whichCgi, params, callback)
 * 3. 注入自动显示的loading组件
        cgi.injectLoadingUi(loadingUi)
 */

/**
 * @param {String} 必传 opt.appid appid
 * @param {String} 必传 opt.sessionObj session相关的object
 * @param {String} 必传 opt.version 传给cgi的webversion，用来区分前端版本来源
 * @param {Interger} opt.sandbox dev传2，沙箱传1或者true，现网传false或者不传
 * @param {String} opt.pf pf
 * @param {String} opt.pfkey pfkey
 * example
    //引入cgi主模块
    import {cgi} from '@tencent/midas-cgi';
    //登录态相关的类
    import {session_jfrp} from '@tencent/midas-util';

    //创建用户登录态实例
    var sessionObj = new session_jfrp({
      openid : 'xxxx',
      openkey : 'xxxx'
    })

    //创建cgi实例
    var cgiObj = new cgi({
      pf : 'x-x-html5',
      appid : '1450001679,
      sessionObj,
      version : 'testExampleV0.1'
    })

    //发起对reward_pf_query的cgi请求
    //请参考cgiObj.request方法
 */
export default class cgi {
  constructor(opt) {
    if (!opt.version) {
      throw new Error("cgi need version params");
    }

    this.pf = opt.pf || 'vip_m-pay_html5-html5';

    this.pfkey = opt.pfkey || 'pfkey';

    this.appid = opt.appid;

    this.experience = false
    
    if (opt.sandbox === 4) {
      this.experience = true
      opt.sandbox = 0
    }

    if (opt.sandbox) {
      this.sandbox = [1, 2, 3].indexOf(opt.sandbox) !== -1 ? opt.sandbox : 1;
    } else {
      this.sandbox = 0;
    }

    this.sessionObj = opt.sessionObj;

    //aes加密key
    this.aesKey = this.sandbox ? '0269bd8009164afc' : '2Wozy2aksie1puXU';

    //版本号
    this.version = opt.version;
  }

	/**
   @param whichCgi 用于指定需要请求的cgi
    example:
      //引入具体的cgi配置
    import rewardPfQuery from '@tencent/midas-cgi/cgis/reward_pf_query';
    var myCgi = new rewardPfQuery({
      //设置超时时间，单位为秒，默认没有超时时间
      timeout : 10,
      //隐藏Loading，默认为false。
      //如果需要cgi网络请求阶段自动显示loading提示，请使用cgi.injectLoadingUi方法注入一个Loading组件
      hideLoading : false,
    })

    @param params {Object} cgi请求的参数，参数值如需url编码，请自行编码
      //框架已经自动完成了下面参数的传递
      //openid,openkey,session_id,session_type
      //pf,pfkey,from_h5,session_token,webversion,format,r(随机数)

    @param callback(res) 回调函数，res即为cgi的返回

    @return 如果判断callback参数为空就会返回promise

    //回调函数，有几个特殊返回用来做报错的监控
      1. 如果是cgi请求出错，比如502等，返回res如下
        {
          ret: -9999,
          path: 'cgi的完整url',
          msg: '系统繁忙，请稍后再试！(-9999)'
        }
      2. 如果是cgi返回的内容不是合法的jsonp，返回res如下
        {
          ret: -9998,
          path: 'cgi的完整url',
          msg: '系统繁忙，请稍后再试！(-9998)'
        }
      3. 如果设置了超时时间timeout，超时返回res如下
        {
          ret: -9997,
          path: 'cgi的完整url',
          msg: '对不起，请求超时！'
        }

    example:
    //发起cgi请求
    cgiObj.request(myCgi, {
      action : 'query_coupon_list',
      coupon_type : 'redeem'
    }, res => {
      //处理cgi返回信息
    })
   */
  request(whichCgi, params, callback) {
    if (!this.appid) {
      throw new Error("You should use cgiObj.setAppid(appid) to set appid before calling cgiObj.request()");
    }

    if (!this.sessionObj) {
      throw new Error("You should use cgiObj.setSession(sessionObj) to set sessionObj before calling cgiObj.request()");
    }

    var opt = {
      hideLoading: whichCgi.hideLoading,
      timeout: whichCgi.timeout,
      aesKeys: whichCgi.aesKeys(),
      needDeleteKeys: whichCgi.needDeleteKeys,
    }

    if (!callback) {
      return new Promise(resolve => {
        if (whichCgi.requestType === 'ajax') {
          this.ajaxCgiRequest(whichCgi, params, res => resolve(res), opt)
        } else {
          this.cgiRequest(whichCgi, params, res => resolve(res), opt)
        }
      })
    } else {
      if (whichCgi.requestType === 'ajax') {
        this.ajaxCgiRequest(whichCgi, params, callback, opt)
      } else {
        this.cgiRequest(whichCgi, params, callback, opt)
      }
    }
  }

	/**
     * Jsonp方式请求CGI数据
     * @param whichCgi {Object}
     * @param params {Object} cgi的get参数部分
     * @param callback {Function}
     * @param option {Object} 其他配置 {hideLoading : false, https : false, aesKeys : []}
     *		object.aesKeys 需要aes加密的字段
     *		object.needDeleteKeys 需要删除的字段
     *		object.hideLoading 隐藏加载url时的loading
     *		object.timeout 超时时间
     */
  cgiRequest(whichCgi, params, callback, option = {}) {
    var uri = whichCgi.getUri(this);
    var getParams = objectAssign({}, params);

    if (/\/cgi-bin\//.test(uri)) {
      getParams.offer_id = this.appid;
    }

    var jsonpName = '_h5pay' + Math.floor(Math.random() * 1000000);
    getParams.format = 'jsonp_' + jsonpName;

    objectAssign(getParams, this._getSessionParam());

    //算aes
    if (option.aesKeys && option.aesKeys.length) {
      let aesParams = this.aesEncrypt(getParams, option.aesKeys);
      objectAssign(getParams, aesParams);
    }

    if (Array.isArray(option.needDeleteKeys)) {
      forEach(option.needDeleteKeys, (key) => {
        try {
          delete getParams[key];
        } catch (e) { }
      });
    }
    var url = uri + (uri.indexOf('?') === -1 ? '?' : '&') + serializeParam(getParams);
    var res;
    var loading;
    if (!option.hideLoading) {
      loading = new cgi.loadingUi({
        showShadow: false
      });
    }
    window[jsonpName] = function (_res) {
      res = _res;
    };
    loadScript(url, (args, isLoaded) => {
      window[jsonpName] = function () { }
      if (loading) {
        loading.close();
      }
      //cgi报错
      if (!isLoaded) {
        if (isLoaded === null) {
          res = {
            ret: -9997,
            path: url,
            msg: '对不起，请求超时！'
          };
        } else {
          res = {
            ret: -9999,
            path: url,
            msg: '系统繁忙，请稍后再试！(-9999)'
          };
        }
      }
      //cgi返回格式错误
      if (!res) {
        res = {
          ret: -9998,
          path: url,
          msg: '系统繁忙，请稍后再试！(-9998)'
        };
      }
      typeof callback == "function" && callback(res);
      if (~~res.ret) {
        //只要错误码不为0，统一上报cgi错误
        this.logdata({
          7: res.ret,
          8: objectAssign({
            $err_code: res.err_code || ''
          }, params),
          21: 'h5pay.cgi.error.' + whichCgi.cgiName()
        });
      }
    }, null, null, option.timeout);
  }

  /**
   * ajax方式请求CGI数据
   * @param whichCgi {Object}
   * @param params {Object} cgi的get参数部分
   * @param callback {Function}
   * @param option {Object} 其他配置 {hideLoading : false, https : false, aesKeys : []}
   *		object.aesKeys 需要aes加密的字段
   *		object.needDeleteKeys 需要删除的字段
   *		object.hideLoading 隐藏加载url时的loading
   *		object.timeout 超时时间
   */
  ajaxCgiRequest(whichCgi, params, callback, option = {}) {
    var getParams = {};
    var uri = whichCgi.getUri(this);
    if (/\/cgi-bin\//.test(uri)) {
      getParams.offer_id = this.appid;
    }
    objectAssign(getParams, params);

    objectAssign(getParams, this._getSessionParam());

    if (typeof document.referrer === "string") {
      getParams.__refer = encodeURIComponent(document.referrer);
    }

    //算aes
    if (option.aesKeys && option.aesKeys.length) {
      let aesParams = this.aesEncrypt(getParams, option.aesKeys);
      objectAssign(getParams, aesParams);
    }

    if (Array.isArray(option.needDeleteKeys)) {
      forEach(option.needDeleteKeys, (key) => {
        try {
          delete getParams[key];
        } catch (e) { }
      });
    }

    var loading;
    if (!option.hideLoading) {
      loading = new cgi.loadingUi({
        showShadow: false
      });
    }

    var excuteCallback = res => {
      typeof callback == "function" && callback(res);
      //只要错误码不为0，统一上报cgi错误
      if (~~res.ret) {
        this.logdata({
          7: res.ret,
          8: objectAssign({
            $err_code: res.err_code || ''
          }, params),
          21: 'h5pay.cgi.error.' + whichCgi.cgiName()
        });
      }
    }

    var xhr = ajax({
      method: "POST",
      param: getParams,
      url: uri,
      timeout: option.timeout,
      success: res => {
        //cgi返回格式错误
        if (!res) {
          res = {
            ret: -9998,
            path: uri,
            msg: '系统繁忙，请稍后再试！(-9998)'
          };
        }
        excuteCallback(res);
      },
      error: () => {
        let ret = -9000 - xhr.status;
        let res = {
          ret,
          path: uri,
          msg: '系统繁忙，请稍后再试！(' + ret + ')'
        };
        excuteCallback(res);
      },
      complete: () => {
        if (loading) {
          loading.close();
        }
      },
      onTimeout: () => {
        let res = {
          ret: -9997,
          path: uri,
          msg: '对不起，请求超时！'
        };
        excuteCallback(res);
      }
    });
  }

  setSession(obj) {
    this.sessionObj = obj;
  }

  setAppid(appid) {
    this.appid = appid;
  }

  _getSessionParam() {
    return objectAssign({
      pf: this.pf,
      pfkey: this.pfkey,
      from_h5: 1,
      session_token: sessionToken,
      webversion: this.version,
      r: Math.random()
    }, this.sessionObj.getSessionParam());
  }

  logdata(_params) {
    var params = {
      31: this.version,
    }

    if (this.appid) {
      params[24] = this.appid;
    }

    if (this.sessionObj) {
      var sessionParams = this.sessionObj.getSessionParam();

      objectAssign(params, {
        3: sessionParams.openid,
        37: sessionParams.session_id,
        43: sessionParams.session_type,
        41: sessionParams.wx_appid || '',
      })
    }

    logdata(objectAssign({
      26: this.pf,
    }, _params, params))
  }

  aesDecrypt(msg) {
    //解密
    msg = msg || '';
    if (!msg)
      return '';
    msg = msg.replace(/\_.+/g, '');
    msg = CryptoJS.enc.Hex.parse(msg);
    msg = CryptoJS.enc.Base64.stringify(msg);
    var content = CryptoJS.AES.decrypt(msg, CryptoJS.enc.Utf8.parse(this.aesKey), {
      padding: CryptoJS.pad.ZeroPadding,
      mode: CryptoJS.mode.ECB
    });
    return content.toString(CryptoJS.enc.Utf8);
  }

  aesEncrypt(param, keys) {
    //算aes加密
    var aesMsg = [];
    forEach(keys, function (key) {
      aesMsg.push(key + '=' + (param[key] || ''));
    });
    aesMsg = aesMsg.join('&');
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Latin1.parse(aesMsg), CryptoJS.enc.Latin1.parse(this.aesKey), {
      padding: CryptoJS.pad.ZeroPadding,
      iv: CryptoJS.enc.Latin1.parse(this.aesKey),
      mode: CryptoJS.mode.ECB
    }).ciphertext.toString(CryptoJS.enc.Hex);
    return {
      encrypt_msg: encrypted,
      msg_len: aesMsg.length
    }
  }
}

//默认的loadingUi
cgi.loadingUi = class {
  constructor() { }
  close() { }
}

/**
 * @param loadingUi Loading组件的类

 * 注入后，在发起请求前会调用下面方法显示loading浮层
 * var loadingObj = new loadingUi()

 * 请求结束时会调用下面方法隐藏loading浮层
 * loadingObj.close()

 * 注入后，如果某些cgi请求不需要显示loading，可通过传hideLoading参数隐藏
  import rewardPfQuery from '@tencent/midas-cgi/cgis/reward_pf_query';
  var myCgi = new rewardPfQuery({
    hideLoading : false
  })
 */
cgi.injectLoadingUi = function (loadingUi) {
  cgi.loadingUi = loadingUi;
}
